// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mbgu","colMin":"styles_colMin__3cyPi"};